import { message } from 'antd';
import { makeAutoObservable } from 'mobx';
import { IError, IPageable, IQrs, IQrUser } from 'models';
import QrCodesService from 'services/QrCodesService';

class QrStore {
    isLoading = false;
    qrUsers: IQrs | null = null;
    errorQr: IError | null = null;
    errorUpload: IError | null = null;
    successAdd = false;

    setIsLoading(bool: boolean) {
        this.isLoading = bool;
    }

    setQrUsers(data: IQrs) {
        this.qrUsers = data;
    }

    setSuccessAdd(bool: boolean) {
        this.successAdd = bool;
    }

    setError(data: IError | null) {
        this.errorQr = data;
    }

    setAddError(data: IError | null) {
        this.errorUpload = data;
    }

    constructor() {
        makeAutoObservable(this);
    }

    async getQrUsers(pageable: IPageable) {
        this.setIsLoading(true);
        try {
            this.setError(null);
            const response = await QrCodesService.getQrUsers(pageable);
            this.setQrUsers(response.data);
        } catch (error: any) {
            if (error && error?.response && error?.response?.data) {
                this.setError(error.response.data);
            }
        }
        this.setIsLoading(false);
    }

    async addQrUser(data: IQrUser) {
        this.setIsLoading(true);
        try {
            this.setError(null);
            await QrCodesService.qrUserPost(data);
            this.setSuccessAdd(true);
            message.success('QR-код успешно сгенерирован!');
        } catch (error: any) {
            if (error && error?.response && error?.response?.data) {
                this.setError(error.response.data);
            }
        }
        this.setIsLoading(false);
    }

    async uploadQrFile(file: File) {
        this.setIsLoading(true);
        try {
            this.setAddError(null);
            const response = await QrCodesService.uploadFile(file);
            return response.data;
        } catch (error: any) {
            if (error?.response?.data) {
                this.setAddError(error.response.data);
            }
            throw error;
        } finally {
            this.setIsLoading(false);
        }
    }
}

const qrStore = new QrStore();

export default qrStore;
